import { FiCheck, FiCopy } from 'react-icons/fi';

import { ActionIcon, CopyButton, Flex, Text, Tooltip } from '@highlight-cp/core-ui';

interface CopyableValueProps {
  label: string;
  children: string | number | null | undefined;
}

const CopyableValue = (props: CopyableValueProps) => {
  const { label, children } = props;

  if (!children) return;

  const val = String(children);

  return (
    <Flex align="center" gap={5}>
      <Flex gap={5}>
        <Text>{label}:</Text>
        <Text size="sm" c="dimmed">
          {/* The `code` is the trigger, not the Text — see `.reference` in tooltip.module.css. */}
          <Tooltip label={val}>
            <code>
              {/* `truncate` over `lineClamp={1}`: ids and tokens have nothing to wrap at, and a
                  clamp only draws its ellipsis when there is a next line to hide. */}
              <Text span inherit truncate display="block" maw="100px">
                {val}
              </Text>
            </code>
          </Tooltip>
        </Text>
      </Flex>
      <CopyButton value={val} timeout={2000}>
        {/* eslint-disable  @typescript-eslint/unbound-method */}
        {({ copied, copy }) => (
          <Tooltip label={copied ? 'Copied' : 'Copy'} position="right">
            <ActionIcon
              aria-label={copied ? 'Copied' : `Copy ${label}`}
              color={copied ? 'teal' : 'gray'}
              onClick={copy}
            >
              {copied ? <FiCheck size="1rem" /> : <FiCopy size="1rem" />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Flex>
  );
};

export default CopyableValue;
